import { render, staticRenderFns } from "./instructorDetails.vue?vue&type=template&id=721238fe&scoped=true&"
import script from "./instructorDetails.vue?vue&type=script&lang=js&"
export * from "./instructorDetails.vue?vue&type=script&lang=js&"
import style0 from "./instructorDetails.vue?vue&type=style&index=0&id=721238fe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721238fe",
  null
  
)

export default component.exports